import { FC } from "react";
import { IconPropsType } from ".";

export const OptionSign: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#F2F2F2" />
      <path
        d="M11 7.5C11 8.32838 10.3284 9 9.5 9C8.67162 9 8 8.32838 8 7.5C8 6.67162 8.67162 6 9.5 6C10.3284 6 11 6.67162 11 7.5Z"
        fill="#CACACA"
      />
      <path
        d="M16 7.5C16 8.32838 15.3284 9 14.5 9C13.6716 9 13 8.32838 13 7.5C13 6.67162 13.6716 6 14.5 6C15.3284 6 16 6.67162 16 7.5Z"
        fill="#CACACA"
      />
      <path
        d="M11 12.5C11 13.3284 10.3284 14 9.5 14C8.67162 14 8 13.3284 8 12.5C8 11.6716 8.67162 11 9.5 11C10.3284 11 11 11.6716 11 12.5Z"
        fill="#CACACA"
      />
      <path
        d="M16 12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5C13 11.6716 13.6716 11 14.5 11C15.3284 11 16 11.6716 16 12.5Z"
        fill="#CACACA"
      />
      <path
        d="M11 17.5C11 18.3284 10.3284 19 9.5 19C8.67162 19 8 18.3284 8 17.5C8 16.6716 8.67162 16 9.5 16C10.3284 16 11 16.6716 11 17.5Z"
        fill="#CACACA"
      />
      <path
        d="M16 17.5C16 18.3284 15.3284 19 14.5 19C13.6716 19 13 18.3284 13 17.5C13 16.6716 13.6716 16 14.5 16C15.3284 16 16 16.6716 16 17.5Z"
        fill="#CACACA"
      />
    </svg>
  );
};
